import { HttpResult } from 'widgets-for-react'
import { getPressReleases } from '../../drupal/api.mod'
import { PressReleaseItem } from '../blocks/custom_blocks/widgets/pressReleasesBlock'

export async function getPressRelease(id: string): Promise<HttpResult<PressReleaseItem>> {
  const res = await fetch(`/api/v1/globenewswire/${id}`)

  if (!res.ok) return { kind: 'failed', status: 400 }

  const json = await res.json()

  const press_releases = await getPressReleases()
  if (press_releases.kind != 'result' || !press_releases.value.items.find((release) => release['id'] == json['id']))
    return { kind: 'failed', status: 400 }

  return { kind: 'result', status: 200, value: json }
}
